import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { ProfilePicture } from "..";

const ProfilePictureCollectionRoot = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return <div className={twMerge("-space-x-2", className)}>{children}</div>;
};

const Image = ({
  imageUrl,
  name,
  className,
  size = "medium",
}: {
  imageUrl: string | null;
  name?: string | null;
  className?: string;
  size?: "small" | "medium" | "large" | "xl" | "2xl";
}) => {
  return (
    <>
      {imageUrl ? (
        <img
          className={twMerge(
            "border-grey inline h-10 w-10 rounded-full border-2 object-cover",
            className,
            size === "small" &&
              "h-[22px] max-h-[22px] min-h-[22px] w-[22px] max-w-[22px] min-w-[22px]",
          )}
          src={imageUrl}
          alt="Profile image"
        />
      ) : (
        <>
          {name && (
            <ProfilePicture
              className="border-gray border-2"
              name={name}
              size={size}
            />
          )}
        </>
      )}
    </>
  );
};

export {
  ProfilePictureCollectionRoot as ProfilePictureCollection,
  Image as ProfilePictureCollectionImage,
};
